import { render, staticRenderFns } from "./SettingsConfirmOverlay.vue?vue&type=template&id=15db06d8"
import script from "./SettingsConfirmOverlay.vue?vue&type=script&lang=ts"
export * from "./SettingsConfirmOverlay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports